import PublicLayout from "../../modules/ui/components/PublicLayout";
import React from "react";
import TransferRequestView from "../../modules/transfers/components/form/TransferRequestView";

const PageTransfers = () => {
    return (
        <PublicLayout>
            <div className={`nc-CheckOutPage`} data-nc-id="CheckOutPage">
                {/* Banner fullwidth */}
                <div className="w-full">
                    <TransferRequestView showBannerOnly={true}/>
                </div>
                {/* Form container */}
                <main className="container mt-11 mb-24 lg:mb-32 flex justify-center">
                    <div className="w-full lg:w-5/5 xl:w-3/3">
                        <TransferRequestView showFormOnly={true}/>
                    </div>
                </main>
            </div>
        </PublicLayout>
    );
}

export default PageTransfers;
